import { createSelector } from "@ngrx/store";
import { getCountry, getFilter, getTypes } from "./filter.selector";
import { getLoading, getUsers, getCountryLeaderboardsLoading as getCLeaderboardsLoading, getCountryLeaderboardsData as getCLeaderboardsData, getCountryLeaderboard as getCLeaderboard} from "./leaderboard.selector";

const getFilterState = state => state.filter;

export const getFilterFilter = createSelector(getFilterState, getFilter);
export const getFilterTypes = createSelector(getFilterState, getTypes);
export const getFilterCountry = createSelector(getFilterState, getCountry);

export const getLeaderboardState = state => state.leaderboard;

export const getLeaderboardUsers = createSelector(getLeaderboardState, getUsers);
export const getLeaderboardLoading = createSelector(getLeaderboardState, getLoading);
export const getCountryLeaderboardsLoading = createSelector(getLeaderboardState, getCLeaderboardsLoading);
export const getCountryLeaderboardsData = createSelector(getLeaderboardState, getCLeaderboardsData);
export const getCountryLeaderboard = createSelector(getLeaderboardState, getCLeaderboard);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/selectors/selectors.ts